import React, { useEffect, useMemo, useRef, useState } from "react"

import modStyl from './index.module.scss'

import Condition from "./components/condition"
import { Button, Empty, Table } from "antd"
import { ColumnsType } from "antd/lib/table"
import { readTargetName } from "../../../utils/storage"
import { ClosingManagementPayload, getClosingManagementList } from "../../../services/dct/visit"

const items = [
  {label: '批量结算', key: 1},
  {label: '批量废弃', key: 2},
]

export type DataResult = {
  code: number;
  message?: string;
  data: {
    page: number;
    pageSize: number;
    total: number;
    rows: DataType[];
  }
}

export type DataType = {
  id: string
  qid: string
  label: string
  projectName: string
  content: string
  subjectCode: string
  dataCode: string
  deCode: string
  enter: string
  formId: null
  formName: string
  questionCreateUser: string
  questionRole: string
  questionCreateTime: string
  questionId: string
  questionText: string
  questionStatus: string
  replierCreateUser: string
  replierRole: string
  replierCreateTime: string
  closeCreateUser: string
  closeRrole: string
  closeCreateTime: string
  visitName: string
  isLock: null
}

const ClosingManagement = ()=> {

  const [pageSize] = useState(20)
  const [pageNum, setPageNum] = useState(1)
  
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  
  const [dataSource, setDataSource] = useState<DataType[]>([])

  const targetName = useMemo(()=> readTargetName(), [])

  const [type, setType] = useState(1)

  const [condition, setCondition] = useState({} as Omit<ClosingManagementPayload, 'type'>)

  //#region 表格列
  const columns: ColumnsType<DataType> = [
    {
      width: 120,
      align: 'center',
      title: '项目编码',
      dataIndex: 'projectName',
    },
    {
      width: 120,
      align: 'center',
      title: `${targetName}编码`,
      dataIndex: 'subjectCode',
    },
    {
      width: 160,
      title: '结算导入时间',
      dataIndex: 'createTime',
    },
    {
      width: 120,
      title: '创建人',
      dataIndex: 'createUser',
    },
  ];
  //#endregion

  const fetchData = async (params: ClosingManagementPayload, page = 1)=> {
    setLoading(true)
    const { code, data } = await getClosingManagementList(page, pageSize, params)
    if (code === 0) {
      setLoading(false)
      setPageNum(page)
      setTotal(data.total)
      setDataSource(data.records)
    }
  }

  const onSearch = (params?: Omit<ClosingManagementPayload, 'type'>)=> {
    if (typeof params === 'undefined') {
      setType(1)
    }
    setCondition({ ...params })
  }

  useEffect(()=> {
    fetchData({type, ...condition})
  }, [type, condition])

  return (
    <div className={modStyl.wrapper}>
      <Condition type={type} onSearch={onSearch}/>
      <div className={modStyl.tab}>
        {
          items.map(({label, key})=> (
            <Button onClick={()=> setType(key)} type={key === type ? 'primary' : 'default'} key={key}>{label}</Button>
          ))
        }
      </div>
      <div className={modStyl.tableWrapper}>
        <Table
          loading={loading}
          size="middle"
          rowKey="subjectCode"
          scroll={{y: window.innerHeight - 300}}
          columns={columns}
          dataSource={dataSource}
          locale={{emptyText: <Empty description="暂无数据"/>}}
          pagination={{
            onChange: (page: number)=> fetchData({...condition, type}, page),
            total: total,
            current: pageNum,
            pageSize: pageSize,
            hideOnSinglePage: false,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: total=> `共${total}条，每页${pageSize}条`,
            position: ["bottomRight"]}}/>
      </div>
    </div>
  )
}

export default ClosingManagement